import ignoreFields from "@/lib/ignoreFields";
import { store } from "@/store/store";
import { NestedKeyOf } from "@/v2/types";
import { ModuleKey } from "../rbac/modules";

///EXPORTS
export * from "./utils/parseUserFromFilter.ts";
export * from "./utils/buildFilterObj.ts";

type id<T> = keyof T | NestedKeyOf<T>;

export interface NumberRange {
    min: number | null;
    max: number | null;
}

export interface DateRange {
    min: Date | null;
    max: Date | null;
}

export interface ComboBoxRange {
    id: string | null;
    value: string | null;
}

export type FilterColumn<T> = {
    id: id<T> | "sl" | "actions";
    filterId?: string;
    headingText?: string;
    [key: string]: any;
};

export function generateFilterColumn<T>(
    columns: FilterColumn<T>[],
    options?: {
        removeIds?: id<T>[];
        renameMap?: Partial<Record<id<T>, string>>;
        addFilterId?: Partial<Record<id<T>, string>>;
    },
    module?: ModuleKey,
): FilterColumn<T>[] {
    const user = store.getState().user.value;

    const filteredColumns = module
        ? columns.filter((cell) => {
              return (
                  ignoreFields(user, {
                      module,
                      column: cell.id as string,
                  }) !== true
              );
          })
        : columns;

    const { removeIds = [], renameMap, addFilterId } = options || {};
    const excluded = new Set(["sl", "actions", ...removeIds]);
    return filteredColumns
        .filter((col): col is FilterColumn<T> => !excluded.has(String(col.id)))
        .map(
            (col): FilterColumn<T> => ({
                ...col,
                id: col.id as keyof T | NestedKeyOf<T>,
                headingText:
                    renameMap?.[col.id as id<T>] ?? col.headingText ?? "",
                filterId:
                    addFilterId?.[col.id as id<T>] ?? String(col.id) ?? "",
            }),
        );
}

export const FilterFields = {
    date: [
        "mobilized_date",
        "de_mobilized_date",
        "id_expiry",
        "plant_id_expiry",
        "invoice_date",
        "invoice_due_date",
        "enquire_date",
        "issued_date",
        "expiration_date",
        "quotation_date",
    ],
    number: [
        "supplier_rate",
        "food_accommodation_and_travel",
        "client_rate",
        "client_commission",
        "supplier_commission",
        "ar_four_percent",
        "margin",
        "invoice_amount",
        "invoice_amount_including_vat",
        "invoice_vat",
        "total_amount",
        "invoice_paid_amount",
    ],
    boolean: ["is_mobilized", "completed"],
    comboBox: [
        "employees.full_name",
        "clients.full_name",
        "suppliers.full_name",
        "ar_coordinators.full_name",
        "supporting_coordinators.full_name",
        "projects.name",
    ],
    arrayFilter: ["trade"],
};
